import React from 'react';
import UntentiList from './UtentiList';
import FirmaList from '../firma/FirmaList';

const UtentiDashboardPage = () => (
  <div>
    <UntentiList />
    <FirmaList />
  </div>
);

export default UtentiDashboardPage;



// WEBPACK FOOTER //
// ./src/components/utenti/UtentiDashboardPage.js